import { Component } from '@angular/core';
import { PrimeNGButtonDeleteItemActionComponent } from '@ntap/primeng';
import { map } from 'rxjs';

@Component({
  selector: 'app-predaja-delete-action',
  templateUrl: '../../../shared/components/actions/common-action-template.html'
})
export class PredajaDeleteActionComponent extends PrimeNGButtonDeleteItemActionComponent {
  protected override initDisabledObservable(): void {
    this.isDisabled$ = this.itemProvider.item$.pipe(
      map(
        (item) =>
          (item as any)['earhiv~predaja_gradiva~status_predaje'] !== 'U_RADU'
      )
    );
  }
}
